import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Link from "./components/Links";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Skills />
      <Projects />
      <Contact />
      <Link />
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js